import { Injectable, NgModule } from '@angular/core';
import { RouterModule, Routes, RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
//import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { OktaAuthGuard } from '../guards/okta-auth-guard';
import { LoginComponent } from './auth/login/login.component';
import { MainMenuComponent } from './main/main-menu/main-menu.component';
import { LoggedoutComponent } from './auth/loggedout/loggedout.component';
import { LoginCallbackComponent } from './auth/login-okta-callback/login-okta-callback.component';
import { LoginErrorComponent } from './auth/login-error/login-error.component';
import { ImpersonateComponent } from './main/impersonate/impersonate.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { HomeComponent } from './main/home/home.component';

@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
  }

  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Reuse the route if both routes have the reuseComponent flag set to true
    if (future.data['reuseComponent'] && curr.data['reuseComponent']) {
      return true;
    }
    // Default behavior: reuse if same route config
    return future.routeConfig === curr.routeConfig;
  }
}

const routes: Routes = [
  { path: '', title: 'NHA App', component: HomeComponent },
  { path: 'mainmenu', component: MainMenuComponent, title: 'Home', canActivate: [OktaAuthGuard] },
  //{ path: 'callback', component: OktaCallbackComponent },
  { path: 'callback', component: LoginCallbackComponent },
  { path: 'impersonate', component: ImpersonateComponent, canActivate: [OktaAuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'loggedout', component: LoggedoutComponent },
  { path: 'error', component: LoginErrorComponent },
  {
    path: 'apps',
    loadChildren: () => import(`./apps/apps-routing.module`).then((m) => m.AppsRoutingModule),
    canActivate: [OktaAuthGuard]
  },
  // Public guest surface (UserType Guest, no Okta). Deliberately NO OktaAuthGuard — auth is the
  // Guest JWT obtained by redeeming the emailed code. Matches GuestLink.Path on the server.
  {
    path: 'guest',
    loadChildren: () => import(`./guest/guest.module`).then((m) => m.GuestModule)
  },
  // Public post share link (Posts.IsPublic). No guard: the page itself sends logged-in users to
  // the normal detail route and renders a read-only view for everyone else.
  {
    path: 'p/:id',
    loadComponent: () => import(`./public/public-post.component`).then((m) => m.PublicPostComponent),
    title: 'View Post'
  },
  { path: '**',   redirectTo: '', pathMatch: 'full' },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: CustomReuseStrategy
    }
  ]
})
export class AppRoutingModule { }
